import { Form, Input, Message } from '@alifd/next';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import client from '@/lib/feathers';
import { fetchUser } from '@/redux/slices/userSlice';

import {
  checkNickNameAndResidentNameIsSame,
  findSameHouseholdUsers,
  handleSubmitErrors,
  jumpPage,
  resetPassword,
  updateFile,
  updateUserInfo,
} from './helpers';
import styles from './index.module.scss';

const { Item } = Form;
const DEFAULT_DATA = {
  name: '',
};

const SettingPersonBlock = (props) => {
  const { dataSource = DEFAULT_DATA } = props;
  const [postData, setValue] = useState(dataSource);
  const [currentAuthImg, setCurrentAuthImg] = useState('');
  const [currentAuthId, setCurrentAuthId] = useState('');
  const [currentNameStatus, setCurrentNameStatus] = useState(false);

  //uploads file

  const [parsed, setParsed] = useState([]);
  const [parsed64, setParsed64] = useState([]); //Base64
  const uploadFile = useRef(null);
  const [dataEmail, setDataEmail] = useState('');
  const [householdNumbers, setHouseholdNumbers] = useState([]);
  // console.log(verifyPasswordVal)

  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!user?.auth?.user?._id) {
      dispatch(fetchUser());
    }
  }, [dispatch, user]);

  useEffect(() => {
    client.reAuthenticate().then((data) => {
      console.log('==re login ok', data);
      setDataEmail(data.user.email);
      setValue({ name: data.user.name, email: data.user.email });
      setCurrentAuthImg(data.user.img);
      setCurrentAuthId(data.user._id);
      setHouseholdNumbers(data.user.householdNumbers);
    });
  }, []);

  const beforeUpload = async () => {
    const isLt20M = (await uploadFile.current.files[0].size) / 1024 / 1024 < 20;
    if (!isLt20M) {
      Message.error('Image must smaller than 20MB!');
      return Promise.reject();
    }
    return Promise.resolve(isLt20M);
  };

  const handleFiles = async () => {
    try {
      await beforeUpload();
      const files = [...parsed];
      const data = await uploadFile.current.files[0];
      files.push(data);
      setParsed(files);

      //轉Base64 上傳檔案後呈現沒有寫到DB
      const reader = new FileReader();
      reader.onload = function () {
        let dataURL = reader.result;
        setParsed64(dataURL);
      };
      reader.readAsDataURL(data);
    } catch (err) {
      console.log(err);
    }
  };

  const formChange = (values) => {
    setValue(values);
  };

  const DEFAULT_ON_SUBMIT = async (values, errors) => {
    const { name, email } = values;

    const hasErrors = handleSubmitErrors({ values, errors, currentNameStatus });
    if (hasErrors) {
      return;
    }

    const foundUsers = await findSameHouseholdUsers(householdNumbers);

    if (foundUsers && foundUsers.length > 0) {
      const isSame = checkNickNameAndResidentNameIsSame({
        users: foundUsers,
        newNickName: values.name,
        dataEmail,
      });
      if (isSame) {
        return Message.error('暱稱不得與同住戶一樣，請更換暱稱!!');
      }
      await updateUserInfo({ currentAuthId, name, email });
    }

    if (!foundUsers) {
      await updateUserInfo({ currentAuthId, name, email });
    }

    if (values.password && values.rePassword) {
      await resetPassword(values.password);
    }

    const hasNewUploadFile = uploadFile.current.files.length > 0;
    if (hasNewUploadFile) {
      await updateFile(uploadFile.current.files[0]);
    }

    Message.success('資料更新成功');

    jumpPage();
  };

  const checkPass = (rule, values, callback) => {
    if (values && values !== postData.password) {
      return callback('密碼不一致');
    }
    return callback();
  };

  return (
    <>
      <div className={styles.mobilePersonContainer}>
        <div className={styles.mobilePersonBackground} />
        <Form
          value={postData}
          labelAlign="top"
          onChange={formChange}
          // responsive
        >
          <div className={styles.personBox}>
            <div className={styles.personLeftBox}>
              <img
                className={styles.personImg}
                src={
                  parsed64.length > 0
                    ? parsed64
                    : currentAuthImg
                    ? currentAuthImg
                    : 'icon/ic_photo.svg'
                }
                alt="personImg"
              />
              <label className={styles.fileInput}>
                <input
                  accept="image/png, image/jpeg ,image/jpg"
                  ref={uploadFile}
                  onChange={handleFiles}
                  type="file"
                  id="file"
                  name="files"
                />
                選擇檔案
              </label>
              <div className={styles.imgText}>
                * 頭像盡量上傳超過 80px*80px, 但不要太大
              </div>
              <div className={styles.imgText}>* 請上傳兩倍圖保證清晰度</div>
            </div>
            <div className={styles.personRightBox}>
              <Item label="暱稱" className={styles.nickName}>
                <Input
                  className={styles.nickNameInput}
                  placeholder="請輸入暱稱"
                  name="name"
                  defaultValue={postData.name}
                  onChange={() => {
                    setCurrentNameStatus(true);
                  }}
                />
              </Item>

              {user?.auth?.user?.keyboardAccount !== '物業keyboard帳號' && (
                <>
                  <Item label="帳號" className={styles.nickName}>
                    <Input
                      className={styles.nickNameInput}
                      placeholder="請輸入帳號"
                      name="email"
                      defaultValue={postData.dataEmail}
                      onChange={() => {
                        setCurrentNameStatus(true);
                      }}
                    />
                  </Item>
                  <Item label="重設密碼" className={styles.nickName}></Item>{' '}
                  <Item label="" className={styles.nickName}>
                    <Input.Password
                      className={styles.passwordText}
                      name="password"
                      size="large"
                      placeholder="重設新密碼"
                    />
                  </Item>
                  <Item
                    label=""
                    className={styles.nickName}
                    validator={checkPass}
                  >
                    <Input.Password
                      name="rePassword"
                      size="large"
                      placeholder="確認新密碼"
                    />
                  </Item>
                </>
              )}
            </div>
          </div>
          <div className={styles.personBottomBox}>
            <Item>
              <Form.Submit
                type="primary"
                className={styles.safe}
                onClick={DEFAULT_ON_SUBMIT}
                validate
              >
                儲存
              </Form.Submit>
            </Item>
          </div>
        </Form>
      </div>
    </>
  );
};

export default SettingPersonBlock;
